import { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { upsertMeta } from "@/lib/seo";

/**
 * Catch-all 404. The markup does not depend on the URL (both languages are
 * shown), so the prerendered dist/404.html hydrates cleanly on any path.
 */
const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
    // When the host falls back to the home page HTML, drop its index signals.
    document.title = "Page introuvable / Page not found | ReFound";
    upsertMeta("name", "robots", "noindex, follow");
    upsertMeta("name", "googlebot", "noindex, follow");
    upsertMeta("name", "bingbot", "noindex, follow");
    document.head
      .querySelectorAll('link[rel="canonical"], link[rel="alternate"][hreflang]')
      .forEach((el) => el.remove());
  }, [location.pathname]);

  return (
    <main className="flex min-h-screen items-center justify-center bg-muted px-5 py-16">
      <div className="w-full max-w-2xl text-center">
        <Link to="/" className="inline-block">
          <img src="/logo-test-myreceipt-17.png" alt="ReFound" className="mx-auto h-7 w-auto" />
        </Link>
        <p className="mt-8 text-6xl font-bold tracking-tight text-foreground">404</p>
        <div className="mt-8 grid gap-6 text-left sm:grid-cols-2">
          <section lang="fr-CA" className="rounded-xl border bg-background p-5 shadow-sm">
            <h1 className="text-lg font-semibold text-foreground">Page introuvable</h1>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              Cette page n’existe pas ou a été déplacée.
            </p>
            <div className="mt-4 flex flex-col gap-2">
              <Button asChild><Link to="/">Retour à l’accueil</Link></Button>
              <Button asChild variant="outline"><Link to="/blog">Lire le blogue</Link></Button>
              <Button asChild variant="outline"><Link to="/download">Télécharger ReFound</Link></Button>
            </div>
          </section>
          <section lang="en-CA" className="rounded-xl border bg-background p-5 shadow-sm">
            <h2 className="text-lg font-semibold text-foreground">Page not found</h2>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              This page doesn’t exist or has been moved.
            </p>
            <div className="mt-4 flex flex-col gap-2">
              <Button asChild><Link to="/en">Back to home</Link></Button>
              <Button asChild variant="outline"><Link to="/en/blog">Read the blog</Link></Button>
              <Button asChild variant="outline"><Link to="/en/download">Download ReFound</Link></Button>
            </div>
          </section>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
